import React from 'react';
import { project } from '../data';
import CountUp from "react-countup"

const Counters = () => {
  return (
    <>
  <div className='hero counter '>
        <div className='grid lg:mx-16 grid4 justify-center'>
          {project.map((item) => (
            <div className='box' data-aos='zoom-in'>
              <h1 className='text-accent text-3xl lg:text-5xl font-tertiary lg:font-extrabold '>
                <CountUp enableScrollSpy duration={3} end={item.num} />+
              </h1>
              <h3 className='text-accent text-1xl lg:text-2xl font-tertiary lg:font-extrabold '>{item.title}</h3>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}

export default Counters